import WhiteSpace from "./white-space"

export { WhiteSpaceSize } from "./white-space"

export default WhiteSpace
